import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { DividerComponent, HeadingComponent, IconComponent } from '@core/user-interface-legacy';

import { TellentAssistantBrandMarkComponent } from '../brand-mark/tellent-assistant-brand-mark.component';

@Component({
  selector: 'tellent-assistant-empty-state',
  standalone: true,
  imports: [DividerComponent, HeadingComponent, IconComponent, TellentAssistantBrandMarkComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (loading()) {
      <div class="skeleton" aria-busy="true"></div>
    } @else {
      <header class="intro">
        <div class="brand-wrap">
          <tellent-assistant-brand-mark />
        </div>
        <rt-heading variant="heading large lighter" class="greeting">
          Hey {{ userName() }},
        </rt-heading>
        <rt-heading variant="heading large-x">What can I do for you?</rt-heading>
      </header>
      <ul class="suggestions">
        @for (suggestion of suggestions(); track suggestion) {
          @if (!$first) {
            <rt-divider />
          }
          <li class="suggestion" (click)="suggestionClick.emit(suggestion)">
            <span class="label">{{ suggestion }}</span>
            <rt-icon
              name="keyboard-arrow-right"
              colorToken="colorIconAiStrongDefault"
              class="chevron"
            />
          </li>
        }
      </ul>
    }
  `,
  styleUrls: ['./tellent-assistant-empty-state.component.less'],
})
export class TellentAssistantEmptyStateComponent {
  public readonly userName = input.required<string>();
  public readonly suggestions = input.required<readonly string[]>();
  public readonly loading = input<boolean>(false);
  public readonly suggestionClick = output<string>();
}
